import {
  CM_CONTRACT_START,
  CM_CONTRACT_END,
  CM_CONTRACT_BY_ID,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

const CMTypes = (type, data) => ({ type, data });

const BASE_API = '/contract-management/contract';

// ─── Contract CRUD ────────────────────────────────────────────────────────────

export const getContractManagementContract = (id, isPendingContract) => {
  return (dispatch) => {
    dispatch(CMTypes(CM_CONTRACT_START));
    getContractManagementContractAPI(id, isPendingContract)
      .then((response) => {
        dispatch(CMTypes(CM_CONTRACT_BY_ID, response.data.response));
        dispatch(CMTypes(CM_CONTRACT_END));
      })
      .catch(() => dispatch(CMTypes(CM_CONTRACT_END)));
  };
};

const getContractManagementContractAPI = (id, isPendingContract) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  const url = isPendingContract ? `${BASE_API}/${id}?is_pending_contract=true` : `${BASE_API}/${id}`;
  return axios.get(url, { headers });
};

export const submitContractManagementContract = (type, id, data) => {
  return async (dispatch) => {
    dispatch(CMTypes(CM_CONTRACT_START));
    try {
      const response = await submitContractManagementContractAPI(type, data);
      dispatch(CMTypes(CM_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(CMTypes(CM_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError };
      }
      throw error;
    }
  };
};

const submitContractManagementContractAPI = (type, data) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (type === 'edit') return axios.put(BASE_API, data, { headers });
  return axios.post(BASE_API, data, { headers });
};

export const deleteContractManagementContract = (id) => {
  return async (dispatch) => {
    dispatch(CMTypes(CM_CONTRACT_START));
    try {
      const response = await deleteContractManagementContractAPI(id);
      dispatch(CMTypes(CM_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || 'Deleted successfully');
        return { success: true, response };
      }
    } catch (error) {
      dispatch(CMTypes(CM_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) await handleExecutionLog(dispatch, logNumber);
      throw error;
    }
  };
};

const deleteContractManagementContractAPI = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.delete(`${BASE_API}/${id}`, { headers });
};
